export var MediaType;
(function (MediaType) {
    MediaType["Book"] = "Book";
    MediaType["Film"] = "Film";
    MediaType["Television"] = "Television";
})(MediaType || (MediaType = {}));
;
export var MediaInstallment;
(function (MediaInstallment) {
    MediaInstallment["Book"] = "Chapter";
    MediaInstallment["Film"] = "Installment";
    MediaInstallment["Television"] = "Episode";
})(MediaInstallment || (MediaInstallment = {}));
;
